document.addEventListener("DOMContentLoaded", () => {
  // Tabs
  document.querySelectorAll(".hk-tabs").forEach((tabs) => {
    const buttons = tabs.querySelectorAll(".hk-tabs__tab");
    const panels = tabs.querySelectorAll(".hk-tabs__panel");

    const activate = (btn) => {
      buttons.forEach((b) => {
        b.classList.remove("is-active");
        b.setAttribute("aria-selected", "false");
      });
      panels.forEach((p) => {
        p.classList.remove("is-active");
        p.hidden = true;
      });

      btn.classList.add("is-active");
      btn.setAttribute("aria-selected", "true");

      const targetSel = btn.getAttribute("data-target");
      const target = targetSel ? tabs.querySelector(targetSel) : null;
      if (target) {
        target.hidden = false;
        target.classList.add("is-active");
      }
    };

    buttons.forEach((btn) => btn.addEventListener("click", () => activate(btn)));
  });

  // Sticky bar show/hide
  const sticky = document.querySelector(".hk-stickybar");
  if (!sticky) return;

  const showAfter = 600;

  const onScroll = () => {
    const y = window.scrollY || document.documentElement.scrollTop;
    const nearBottom = window.innerHeight + y > document.documentElement.scrollHeight - 250;

    if (y > showAfter && !nearBottom) sticky.classList.add("is-visible");
    else sticky.classList.remove("is-visible");
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // Qty buttons (in sticky)
  sticky.querySelectorAll("[data-qty]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const input = sticky.querySelector(".hk-stickybar__qtyinput");
      if (!input) return;

      const delta = parseInt(btn.getAttribute("data-qty"), 10);
      const next = Math.max(1, parseInt(input.value || "1", 10) + delta);

      input.value = next;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  // ----------------------------
  // Variant sync (Top <-> Sticky)
  // ----------------------------
  const productInfo = document.querySelector("product-info");
  const stickySelect =
    sticky.querySelector(".hk-stickybar__variant") || document.querySelector('[id^="hkStickyVariant-"]');

  if (!productInfo || !stickySelect) return;

  // Your main-product.liquid sets these, so use them
  const sectionId =
    stickySelect.getAttribute("data-section-id") ||
    (stickySelect.id && stickySelect.id.split("hkStickyVariant-")[1]) ||
    null;

  const productUrl =
    stickySelect.getAttribute("data-product-url") ||
    productInfo.getAttribute("data-url") ||
    window.location.pathname;

  if (!sectionId || !productUrl) return;

  let isSyncing = false;

  function syncStickyPriceFromMain() {
    const main = document.querySelector(`#price-${sectionId} .price__container`);
    const stickyPrice = document.querySelector(`#hkStickyPrice-${sectionId} .price__container`);
    if (!main || !stickyPrice) return;
    stickyPrice.innerHTML = main.innerHTML;
  }

  function syncStickyFromHiddenInput() {
  const hiddenId = document.querySelector(`form[id="product-form-${sectionId}"] input[name="id"]`);
  if (!hiddenId || !hiddenId.value) return;

  // Update sticky dropdown
  setStickyVariantValue(hiddenId.value);

  // Update sticky price from main
  syncStickyPriceFromMain();
}

  // Listen for "top" variant changes via hidden variant input
  const hiddenVariantInput = document.querySelector(`form[id="product-form-${sectionId}"] input[name="id"]`);
  if (hiddenVariantInput) {
    // 1) Normal change event
    hiddenVariantInput.addEventListener("change", () => {
      syncStickyFromHiddenInput();
    });

    // 2) Some themes update the value without firing change, so observe value attribute too
    const obs = new MutationObserver(() => {
      syncStickyFromHiddenInput();
    });
    obs.observe(hiddenVariantInput, { attributes: true, attributeFilter: ["value"] });
  }


  function setStickyVariantValue(variantId) {
    if (!variantId) return;
    if (stickySelect.value !== String(variantId)) {
      isSyncing = true;
      stickySelect.value = String(variantId);
      // release on next tick
      setTimeout(() => (isSyncing = false), 0);
    }
  }

  // TOP -> STICKY (Dawn fires this when top options change)
  productInfo.addEventListener("variant:change", (event) => {
    const variant = event?.detail?.variant;
    if (!variant) return;

    setStickyVariantValue(variant.id);
    syncStickyPriceFromMain();
  });

  // STICKY -> TOP
  stickySelect.addEventListener("change", (e) => {
    if (isSyncing) return;

    const variantId = e.target.value;
    if (!variantId) return;

    // Keep URL clean (optional, but helpful)
    const url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url.toString());

    // Build requestUrl exactly like Dawn expects (include section_id)
    const requestUrl = `${productUrl}${productUrl.includes("?") ? "&" : "?"}variant=${encodeURIComponent(
      variantId
    )}&section_id=${encodeURIComponent(sectionId)}`;

    // IMPORTANT: Your renderProductInfo REQUIRES callback
    if (typeof productInfo.renderProductInfo === "function") {
      productInfo.renderProductInfo({
        requestUrl,
        targetId: stickySelect.id || "",

        callback: (html) => {
          // Replace ONLY the top product info container (price + options)
          const newInfo = html.querySelector(`#ProductInfo-${sectionId}`);
          const curInfo = document.querySelector(`#ProductInfo-${sectionId}`);

          if (newInfo && curInfo) {
            curInfo.innerHTML = newInfo.innerHTML;
          }

          // After DOM swap, sync sticky price from updated main price
          syncStickyPriceFromMain();

          // Also ensure sticky select reflects whatever variant Shopify resolved to
          // (in case of sold out / unavailable combos)
          const newHiddenId = document.querySelector(`form[id="product-form-${sectionId}"] input[name="id"]`);
          if (newHiddenId?.value) setStickyVariantValue(newHiddenId.value);
        },
      });
    }
  });

  // Initial sync on load
  setTimeout(() => {
    // Try to pull current variant from the product form hidden input
    const currentHiddenId = document.querySelector(`form[id="product-form-${sectionId}"] input[name="id"]`);
    if (currentHiddenId?.value) setStickyVariantValue(currentHiddenId.value);
    syncStickyPriceFromMain();
  }, 0);
});
